// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem("userdatatoken");
  // console.log(token);
  return token ? {
    'Content-Type': 'application/json',
    'Authorization': token
  } : {
    'Content-Type': 'application/json'
  };
};

// Helper function to handle authentication errors
export const handleAuthError = (error, setError) => {
  if (error.response && error.response.status === 401) {
    // Clear token if it's invalid
    localStorage.removeItem("userdatatoken");
    setError('Your session has expired. Please log in again.');
    return true;
  }
  return false;
};

// Format date for display
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;

  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);
  const diffWeek = Math.floor(diffDay / 7);
  const diffMonth = Math.floor(diffDay / 30);
  const diffYear = Math.floor(diffDay / 365);

  if (diffSec < 60) {
    return `${diffSec}s`;
  } else if (diffMin < 60) {
    return `${diffMin}m`;
  } else if (diffHr < 24) {
    return `${diffHr}h`;
  } else if (diffDay < 7) {
    return `${diffDay}d`;
  } else if (diffWeek < 4) {
    return `${diffWeek}w`;
  } else if (diffMonth < 12) {
    return `${diffMonth}mo`;
  } else {
    return `${diffYear}y`;
  }
};



// Organize replies into a nested structure
export const organizeReplies = (replyList) => {
  const topLevelReplies = [];
  const replyMap = {};
  
  // First pass: create a map of all replies by ID
  replyList.forEach(reply => {
    reply.children = [];
    replyMap[reply._id] = reply;
  });
  
  // Second pass: organize into parent-child relationships
  replyList.forEach(reply => {
    if (reply?.parentReplyId && replyMap[reply?.parentReplyId]) {
      // This is a child reply, add it to its parent
      replyMap[reply.parentReplyId].children.push(reply);
    } else {
      // This is a top-level reply
      topLevelReplies.push(reply);
    }
  });
  
  return topLevelReplies;
};
const baseUrl = process.env.REACT_APP_BASE_URL;


// API endpoints
export const API_BASE_URL = baseUrl;
export const TOPICS_URL = `${API_BASE_URL}/forum/topics`;
export const REPLIES_URL = `${API_BASE_URL}/forum/replies`;

// Fetch AI model information by name
export const fetchModelInfo = async (modelName) => {
  try {
    const response = await fetch(`${API_BASE_URL}/aimodels/search?modelName=${encodeURIComponent(modelName)}`);
    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        return data.data;
      }
    }
    return null;
  } catch (error) {
    console.error('Error fetching model info:', error);
    return null;
  }
}; 